import React from "react";
import { Link } from "react-router-dom";

type Props = {
  title: string;
  children?: React.ReactNode;
  onClicks?: () => void;
};

export const HeaderCategoryMovil = ({
  title,
  children,
  onClicks,
}: Props): JSX.Element => {
  return (
    <>
      <div className="w-25 mt-2">{children}</div>
      <div
        className={`w-100 d-flex justify-content-center align-items-center mx-auto ${
          title != "" ? "" : "p-3"
        }`}>
        <h4 className="mt-3 text-white">{title}</h4>
      </div>
      <div className="w-25 d-flex justify-content-center align-items-center mx-auto">
        <Link className="header__back" to={"/"} onClick={onClicks}>
          <i className="icon-home3 text-white"></i>
        </Link>
      </div>
    </>
  );
};
